import { lazy } from 'react';

export const CurrencyIconsMap = {
  ['USD']: lazy(() => import('./icons/usd.icon.svg?react')),
  ['EUR']: lazy(() => import('./icons/eur.icon.svg?react')),
  ['GBP']: lazy(() => import('./icons/gbp.icon.svg?react')),
  ['INR']: lazy(() => import('./icons/inr.icon.svg?react')),
} as const;

export type CurrencyCodeType = keyof typeof CurrencyIconsMap;
